import React from "react";
import { LinkWithIcon } from "@boi/react-components";
import { ArrowRightIcon } from "@boi/react-icons";
import * as Buttons from "../../simple-buttons/simple-buttons";
import { PageActionsContainer } from "../../theme/containers";

interface Button extends React.HTMLAttributes<HTMLElement> {
    text?: string;
    variant: string;
    disabled?: boolean;
    label?: string;
}

export type Props = {
    buttons?: Button[];
    cssClass?: string;
};

const variants: { [key: string]: any } = {
    back: Buttons.BackButton,
    primary: Buttons.PrimaryButton,
    secondary: Buttons.SecondaryButton,
    forward: Buttons.ForwardButton
};

const Actions = ({ buttons = [], cssClass }: Props) => (
    <PageActionsContainer className={cssClass}>
        {buttons.map(({ variant, ...button }, i) => {
            if (variant === "forward") {
                return (
                    <LinkWithIcon
                        key={`button[${i}]`}
                        endIcon={<ArrowRightIcon />}
                        variant="bodyM"
                        isUnderlined={false}
                        onClick={button.onClick}
                        href="#"
                    >{button.text || ""}</LinkWithIcon>
                )
            } else {
                const Variant = variants[variant];
                return (
                    <Variant {...button} key={`button[${i}]`} text={button.text || button.label} />
                );
            }
        })}
    </PageActionsContainer>
);

export default Actions;
